import { render } from "./EditCanvasVertical.vue?vue&type=template&id=26a6d48e"
import script from "./EditCanvasVertical.vue?vue&type=script&lang=js"
export * from "./EditCanvasVertical.vue?vue&type=script&lang=js"

import "./EditCanvasVertical.vue?vue&type=style&index=0&id=26a6d48e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__